/**
 * Constant representing the base URL for static content.
 *
 * @type {string}
 */
export const STATIC_BASE_URL = STATIC_URL;
